
export const DiscountMethod = [
  { id: "9f546429-fd47-4fa4-bdf2-35e4bc9b2435", value: "9f546429-fd47-4fa4-bdf2-35e4bc9b2435", name: "Replacement Rate" },
  { id: "7f236153-36a7-49f8-9124-1ccae71fc363", value: "7f236153-36a7-49f8-9124-1ccae71fc363", name: "Floating Discount Factor" }
];

export const BaseIndex = [
  { id: "fd32a2ed-5c56-11ec-b9d7-98fa9bde2f84", value: "fd32a2ed-5c56-11ec-b9d7-98fa9bde2f84", name: "Treasurys" },
  { id: "fd32a2f6-5c56-11ec-b9d7-98fa9bde2f84", value: "fd32a2f6-5c56-11ec-b9d7-98fa9bde2f84", name: "Swaps" }
];

export const FloatingIndex = [
  { id: "a11d7bd4-4681-11e9-82f6-0242ac120002", value: "a11d7bd4-4681-11e9-82f6-0242ac120002", name: "Libor" },
  { id: "b46abe9a-4681-11e9-82f6-0242ac120002", value: "b46abe9a-4681-11e9-82f6-0242ac120002", name: "Libor Three Month" },
  { id: "bca352c6-4681-11e9-82f6-0242ac120002", value: "bca352c6-4681-11e9-82f6-0242ac120002", name: "Libor Six Month" },
  { id: "c6b1a7bb-4681-11e9-82f6-0242ac120002", value: "c6b1a7bb-4681-11e9-82f6-0242ac120002", name: "Term SOFR" },
  { id: "d48732b4-6011-4ef5-8098-98691f75e7ec", value: "d48732b4-6011-4ef5-8098-98691f75e7ec", name: "30 Day Avg SOFR" },
  { id: "d3d84f25-4681-11e9-82f6-0242ac120002", value: "d3d84f25-4681-11e9-82f6-0242ac120002", name: "Overnight SOFR" },
  { id: "ea5cd592-4681-11e9-82f6-0242ac120002", value: "ea5cd592-4681-11e9-82f6-0242ac120002", name: "FedFunds" },
  { id: "f2598911-4681-11e9-82f6-0242ac120002", value: "f2598911-4681-11e9-82f6-0242ac120002", name: "Sifma" },
  { id: "ddab792e-4681-11e9-82f6-0242ac120002", value: "ddab792e-4681-11e9-82f6-0242ac120002", name: "Prime" }
];

export const FirstPeriodAccruals = [
  { id: "ae277ca8-ed37-4004-aaea-2fea11b4bc31", value: "ae277ca8-ed37-4004-aaea-2fea11b4bc31", name: "Use Unaccrued" },
  { id: "5bf7654a-23ac-422e-b884-3b84f18646cf", value: "5bf7654a-23ac-422e-b884-3b84f18646cf", name: "Use Accrued" }
];

export const SpreadType = [
  { id: "3f5dd400-a94c-43cb-b07d-da239de64482", value: "3f5dd400-a94c-43cb-b07d-da239de64482", name: "Spread Array" },
  { id: "ae2be7c9-83ca-4a5b-ab20-250e91a72b89", value: "ae2be7c9-83ca-4a5b-ab20-250e91a72b89", name: "Single Spread" }
];

export const LoanTypes = [
  { value: "4", name: "Balance Sheet" },
  { value: "5", name: "Bridge" },
  { value: "3", name: "CMBS" },
  { value: "1", name: "Construction" },
  { value: "6", name: "Fannie Mae" },
  { value: "7", name: "Freddie Mac" },
  { value: "8", name: "HUD" },
  { value: "11", name: "Life Co" },
  { value: "13", name: "Line of Credit" },
  { value: "12", name: "Mezz" },
  { value: "2", name: "Other Type" },
  { value: "9", name: "Pref Equity" },
  { value: "10", name: "Value-Add" },
  { value: "14", name: "Agency" }
];

export const DYNAMIC = 0;
export const REPLACEMENT = 0;
export const ACCRUED = 0;
export const TREASURYS = 0;

export const FLOATINGDISCOUNT = 1;
export const SWAPS = 1;
export const UNACCRUED = 1;
export const SINGLE = 1;
export const LoanType = 4;
export const SINGLE_SPREAD = "ae2be7c9-83ca-4a5b-ab20-250e91a72b89";
